import { useForm } from "react-hook-form";
import { CreateUser } from "../../../../types/user";
import { CancelButton } from "../../../../components/ui/CancelButton";
import { useState } from "react";
import { UserActions } from "../../PanelActions/enums"; 
import { useCreateUserMutation } from "../../../../api/userApi";
import { getErrorMessage } from "../../../../utils/errorHelpers";
import { ErrorMessage } from "../../../../components/errors/ErrorMessage";
import { SelectCreateEmpresaForm } from "../../../../components/ui/SelectCreateEmpresaForm";
import { InputCreateEmpresaForm } from "../../../../components/ui/InputCreateEmpresaForm";
import { useAdminPanelUI } from "../../../../hooks/useAdminPanelUI";
import { ActionButtons } from "../../../../components/ui/ActionButtons";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

export function CreateUserForm() {
    const { setUserAction } = useAdminPanelUI();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const [createUser, { isLoading, isSuccess }] = useCreateUserMutation();

    const {
        register,
        watch,
        handleSubmit,
        formState: {
            errors,
        },
    } = useForm<CreateUser>();

    const roles = [
        {
            id: 1,
            nombre: "Administrador"
        },
        {
            id: 2,
            nombre: "Prospectador"
        },
        {
            id: 3,
            nombre: "Vendedor"
        }
    ];

    const rolSelected = watch("tipoUsuario");
    const rolVendedorId = "Vendedor";

    const submit = handleSubmit(async (data: CreateUser) => {

        try {
            setErrorMessage(null);

            await createUser(data).unwrap();
            
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }

    });

    return (
        <div className="h-full w-full">
            {isSuccess 
            ?
            <div className="flex flex-col items-center justify-center h-1/2 gap-y-10">
                <div className="flex items-center gap-x-2">
                    <div className="flex items-center justify-center">
                        <CheckCircleRoundedIcon sx={{ height: 30, width: 30, color: "green"}}/>
                    </div>
                    <p className="text-3xl text-center font-semibold">El usuario se ha credo con exitó con exito</p>
                </div>

                <CancelButton
                    text="Regresar"
                    onClick={()=> setUserAction(UserActions.UserList)}/>
            </div>
            :
            <form onSubmit={submit} className="grid" autoComplete="off">

                <div className="flex gap-x-2">

                    <div className="w-[200px] m-3">
                        <p className="text-xl font-semibold">Informacion del usuario</p>
                    </div>

                    <div>

                        <div className="flex gap-x-4 mt-2">
                            <div>
                                <SelectCreateEmpresaForm
                                    height="h-[35px]"
                                    width="w-[300px]"
                                    label="Rol"
                                    register={register("tipoUsuario", {
                                        required: "El rol del usuario es requerido",
                                        min: 1,
                                    })}
                                    datos={roles.map((rol, index) => (
                                        <option key={index} value={rol.nombre}>{rol.nombre}</option>
                                    ))}/>
                                <div className="h-[20px]">
                                    {errors.tipoUsuario?.type === "required" && (
                                        <p className="valErrorText text-sm">{errors.tipoUsuario.message}</p>
                                    )}
                                    {errors.tipoUsuario?.type === "min" && (
                                        <p className="valErrorText text-sm">El rol del usuario es requerido</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="flex gap-x-4 mt-2">

                            <div>
                                <InputCreateEmpresaForm
                                    height="h-[35px]"
                                    width="w-[300px]"
                                    label="Nombre"
                                    register={register("nombre", {
                                        required: "El nombre del usuario es requerido",
                                        maxLength: 50,
                                    })}/>
                                <div className="h-[20px]">
                                    {errors.nombre?.type === "required" && (
                                        <p className="valErrorText text-sm">{errors.nombre.message}</p>
                                    )}
                                    {errors.nombre?.type === "maxLength" && (
                                        <p className="valErrorText text-sm">El número maximo de caracteres es 50</p>
                                    )}
                                </div>
                            </div>

                            {rolSelected != rolVendedorId && (
                            <>
                            <div>
                                <InputCreateEmpresaForm
                                    height="h-[35px]"
                                    width="w-[300px]"
                                    label="Usuario"
                                    register={register("username", {
                                        maxLength: 20
                                    })}/>
                                <div className="h-[20px]">
                                    {errors.username?.type === "maxLength" && (
                                        <p className="valErrorText text-sm">El número maximo de caracteres es 20</p>
                                    )}
                                </div>
                            </div>

                            <div>
                                <InputCreateEmpresaForm
                                    height="h-[35px]"
                                    width="w-[300px]"
                                    label="Correo"
                                    register={register("email", {
                                        maxLength: 50,
                                    })}/>
                                <div className="h-[20px]">
                                    {errors.email?.type === "maxLength" && (
                                        <p className="valErrorText text-sm">El número maximo de caracteres es 50</p>
                                    )}
                                </div>
                            </div>
                            </>
                            )}

                        </div>

                        <div className="flex gap-x-4 mt-2">
                            {rolSelected != rolVendedorId && (
                            <>
                            <div>
                                <InputCreateEmpresaForm
                                    height="h-[35px]"
                                    width="w-[300px]"
                                    label="Contraseña"
                                    type="password"
                                    register={register("password", {
                                        validate: (password, form) => {
                                            if(form.tipoUsuario == rolVendedorId)
                                                return true;

                                            if(password.length == 0)
                                                return false;

                                            return true;
                                        }
                                    })}/>
                                <div className="h-[20px]">
                                    {errors.password?.type === "validate" && (
                                        <p className="valErrorText text-sm">Las contraseñas es requerida</p>
                                    )}
                                </div>
                            </div>

                            <div>
                                <InputCreateEmpresaForm
                                    height="h-[35px]"
                                    width="w-[300px]"
                                    type="password"
                                    label="Confirmar contraseña"
                                    register={register("confirmPassword", {
                                        validate: (confirmPassword, form) => {
                                            if(form.tipoUsuario == rolVendedorId)
                                                return true;

                                            if(form.password != confirmPassword)
                                                return false;
                                            return true;
                                        }
                                    })}/>
                                <div className="h-[20px]">
                                    {errors.confirmPassword?.type === "validate" && (
                                        <p className="valErrorText text-sm">Las contraseñas no coinciden</p>
                                    )}
                                </div>
                            </div>
                            </>
                            )}

                        </div>

                    </div>
                </div>

                {errorMessage && (
                    <div className="my-2">
                        <ErrorMessage
                            customMessage>
                            <p className="text-sm">{errorMessage}</p>
                        </ErrorMessage>
                    </div>
                )}

                <ActionButtons 
                    isLoading={isLoading}
                    saveButtonText="Guardar"
                    onCancel={()=> setUserAction(UserActions.UserList)}/>
            </form>
            }
        </div>
    );
}
